<template>
  <div>
    <div v-if="uploadCount>0 && uploadFileObj" class="file_list mr-3">
      <a @click="onAttView()"><a-icon class="mr-1" type="paper-clip" />{{ uploadFileObj.name }}&nbsp;&nbsp;<span style="font-family:Tahoma;font-size:14px;color: #999999;">{{uploadFileObj.userName}}</span></a>
      <span v-if="hasError" style="color:red">{{ uploadFileObj.response }}</span>
      <span class="ml-3" v-else>{{ uploadFileObj.size }}</span>
    </div>
    <a class="color-main intro-UploadIndex-more" introKey="UploadIndex-more" @click="onUploadSelectorModal"><template v-if="uploadCount>0">[更多附件]<span>{{uploadCount}}</span></template><template v-else-if="isEdit">[新增附件]</template><template v-else>[无附件]</template></a>
    <a class="color-main intro-UploadIndex-batchdownload" introKey="UploadIndex-batchdownload" v-if="uploadCount>0" @click="onDownloadAll()">[<a-icon class="ml-1 mr-1" type="download" />一键下载 ]</a>
    <upload-selector-modal ref="uploadSelectorModal" :referId="referId" :configKey="configKey" :selfUpdate="true" :readonly="readonly" :mangerReadonly="mangerReadonly" :hasRight="hasRight" :max="max" :visible="modalVisible.uploadSelectorModal" :zipTitle="zipTitle" :canUpload="canUpload" @change="onUploadSelectorChange" @HasEdit="e=>{this.isEdit=e}" @cancel="e=>{this.modalVisible.uploadSelectorModal=false; this.uploadCount=e}"/>
  </div>
</template>

<script>
import UploadSelectorModal from '@/components/selector/UploadSelectorModal'

export default {
  name: 'UploadIndex',
  components: { UploadSelectorModal },
  props: {
    referId: {
      type: String,
      required: true,
      default: ''
    },
    configKey: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    mangerReadonly: {
      type: Boolean,
      required: false,
      default: false
    },
    // 是否有操作权限（根据各模块的实际情况）
    hasRight: {
      type: Boolean,
      required: false,
      default: false
    },
    max: {
      type: Number,
      required: false
    },
    // 此字段仅用作融合到 Form 检验必须上传功能
    value: {
      type: String
    },
    zipTitle: {
      type: String,
      required: false,
      default: ''
    },
    canUpload:{
      type:Boolean,
      default:false
    }
  },
  mounted () {
    console.log('readonly', this.readonly)
    console.log('hasRight', this.hasRight)
  },
  watch: {
    referId (val) {
      this.$refs.uploadSelectorModal.refreshData()
    }
  },
  data () {
    return {
      modalVisible: { uploadSelectorModal: false },
      user: this.$ls.get('user'),
      isEdit: true,
      access_token: '',
      configLoading: true,
      uploading: false,
      hasError: false,
      config: null,
      uploadFiles: [],
      uploadCount: 0,
      uploadFileObj: {}
    }
  },
  methods: {
    onUploadSelectorChange ($count, $obj) {
      this.uploadCount = $count
      this.uploadFileObj = $obj
      this.uploadFileObj.referId = this.referId
      this.uploadFileObj.configKey = this.configKey
      this.uploadFileObj.hasRight = this.hasRight
    },
    onUploadSelectorModal () {
      this.$refs.uploadSelectorModal.loadConfig()
      this.modalVisible.uploadSelectorModal = true
    },
    onAttView () {
      this.$refs.uploadSelectorModal.onAttView(this.uploadFileObj)
    },
    onDownloadAll () {
      this.$refs.uploadSelectorModal.onDownloadAll()
    }
  }
}
</script>

<style scoped>
.file_list {
  padding: 6px 0;
  display: inline-flex;
  overflow: hidden;
  position: relative;
  line-height: 20px;
  align-items: center;
}

.file_list a {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1890ff;
}
.color-main{
  color: #1890ff !important;
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  border-left: 1px solid #e6e6e6;
}
.color-main span{
  width: 18px;
  height: 18px;
  background: #ff0000;
  border-radius: 50%;
  display: inline-block;
  color: #fff;
  line-height: 18px;
  text-align: center;
  margin: 0 4px;
}

.file_list .progress {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  background: #e8e8e8
}

.file_list .progress div {
  height: 2px;
  background: #52c41a
}

.file_list .delete {
  position: absolute;
  right: 12px;
}

.file_list .delete:hover i {
  color: #ff0000;
  cursor: pointer;
}

.file_list > span {
  flex: 0 0 auto;
}
</style>
